module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-style",
    staticStyle: {
      "padding": "0px",
      "margin": "-5px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px",
      "margin": "0px"
    }
  }, [(_vm.imageUrl) ? _c('div', {
    staticClass: "col-sm-1",
    staticStyle: {
      "padding": "0px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "src": _vm.imageUrl,
      "height": "80"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'col-sm-11': _vm.imageUrl, 'col-sm-12': !_vm.imageUrl
    }
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "border-bottom": "1px solid #18bc9c"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "5px"
    }
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.patient.firstName) + " " + _vm._s(_vm.patient.lastName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('small', [_vm._v("DOB :")]), _vm._v(" " + _vm._s((_vm.dob)) + " "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Ward :")]), _vm._v(" " + _vm._s(_vm.patient.wardName) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticStyle: {
      "margin": "0px"
    }
  }, [(_vm.patient.generalPractitioner != undefined) ? _c('p', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('strong', [_vm._v(_vm._s(_vm.patient.generalPractitioner.name))]), _vm._v(" (GP)        ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "pull-left"
  }, [_c('small', [_vm._v(_vm._s(_vm.patient.generalPractitioner.phoneNumber))])]), _c('br')]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12  col-xs-12",
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "0px"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills pull-right"
  }, [_c('li', {
    class: {
      'active': _vm.$route.name === 'patient.medstock'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/patient/' + _vm.patient.id + '/' + _vm.carehomeid + '/medstock',
        params: {
          carehomeid: _vm.carehomeid,
          wardid: _vm.patient.wardId,
          patientid: _vm.patient.id
        }
      }
    }
  }, [_vm._v("\n                            Med Stock\n                        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'patient.medprofile'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/patient/' + _vm.patient.id + '/' + _vm.carehomeid + '/medprofile',
        params: {
          carehomeid: _vm.carehomeid,
          wardid: _vm.patient.wardId,
          patientid: _vm.patient.id
        }
      }
    }
  }, [_vm._v("\n                            Med Profile\n                        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'patient.orders'
    }
  }, [_c('router-link', {
    attrs: {
      "exact-active-class": "active",
      "to": {
        path: '/patient/' + _vm.patient.id + '/' + _vm.carehomeid + '/orders',
        params: {
          carehomeid: _vm.carehomeid,
          wardid: _vm.patient.wardId,
          patientid: _vm.patient.id
        }
      }
    }
  }, [_vm._v("\n                            Orders\n                        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'patient.marhistory'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/patient/' + _vm.patient.id + '/' + _vm.carehomeid + '/marhistory',
        params: {
          carehomeid: _vm.carehomeid,
          wardid: _vm.patient.wardId,
          patientid: _vm.patient.id
        }
      }
    }
  }, [_vm._v("\n                            Mar History\n                        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name === 'patient.reports'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/patient/' + _vm.patient.id + '/' + _vm.carehomeid + '/reports',
        params: {
          carehomeid: _vm.carehomeid,
          patientid: _vm.patient.id
        }
      }
    }
  }, [_vm._v("\n                            Print Reports\n                        ")])], 1)])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-094f96a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-094f96a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/patientHeader/patientHeader.scp.html
// module id = 510
// module chunks = 0